import { useState } from 'react'
import TagOrgCustom from './TagOrgCustom'
import { useTranslation } from 'react-i18next'

export default function TagOrgList({
  orgAssign = [],
  direction = 'column',
  isMore = true,
  onExpand
}) {
  const { t } = useTranslation()
  const MAX_SHOW = 4
  const [isExpanded, setIsExpanded] = useState(false)

  const visibleItems =
    !isMore || isExpanded ? orgAssign : orgAssign.slice(0, MAX_SHOW)
  const showMoreBtn = isMore && orgAssign.length > MAX_SHOW && !isExpanded

  if (direction === 'row') {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        {visibleItems.map((org) => (
          <TagOrgCustom key={org.org_id} orgData={org} />
        ))}
        {showMoreBtn && (
          <div
            onClick={() => setIsExpanded(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 20,
              color: '#9CA3AF',
              fontWeight: 400,
              fontSize: 9,
              cursor: 'pointer',
              userSelect: 'none'
            }}
          >
            more+
          </div>
        )}
      </div>
    )
  }

  // direction === 'column'
  const rows = []
  for (let i = 0; i < visibleItems.length; i += MAX_SHOW) {
    rows.push(visibleItems.slice(i, i + MAX_SHOW))
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8}}>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} style={{ display: 'flex', gap: 12 }}>
          {row.map((org) => (
            <TagOrgCustom key={org.org_id} orgData={org} />
          ))}

          {showMoreBtn && rowIndex === rows.length - 1 && (
            <div
              onClick={() => {
                setIsExpanded(true)
                onExpand?.()
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 20,
                color: '#9CA3AF',
                fontWeight: 400,
                fontSize: '12px',
                cursor: 'pointer',
                userSelect: 'none'
              }}
            >
              {t('hrms_setting_leave_more_org')}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
